import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../helpers';
import { LoginService } from '../';
import { AlertService } from '../../services';
import { ErrorHandlerService } from '../../services';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';
import { EventEmitter } from '@angular/core';
var SignupComponent = /** @class */ (function () {
    function SignupComponent(data, router, userService, alertService, errorHandlerService) {
        this.data = data;
        this.router = router;
        this.userService = userService;
        this.alertService = alertService;
        this.errorHandlerService = errorHandlerService;
        this.boolFlag = true;
        this.loadMore = "Load More";
        this.showLess = true;
        this.model = { userCredential: { plainTextPassword: "" }, emailId: "" };
        this.loading = false;
        this.cplainTextPassword = "";
        this.barLabel = "Password strength:";
        this.logintopCourse = [];
        // Error Handler
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Error !!";
        this.showErrorMessages = [];
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.isValidationError = true;
        this.searchfname = "";
        this.searchlname = "";
        this.isLoggedIn = false;
        this.sessionCount = 0;
        this.meetingCount = 500;
        this.countryCount = 0;
        if (localStorage.getItem("authorization") != undefined && localStorage.getItem("authorization") != null && localStorage.getItem("authorization").length > 0) {
            this.isLoggedIn = true;
        }
    }
    SignupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.counterFn(100, 1);
        this.counterFn(600, 2);
        this.counterFn(47, 3);
        this.userService.topcourse()
            .subscribe(function (data) {
            //console.log(data);
            _this.logintopCourse = data;
            //console.log(this.logintopCourse);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            //console.log("Timezone ===> " + this.timezone);
            if (_this.timezone != null) {
                //console.log("Timezone is not null===> " + this.timezone);
                // If there are top courses, then change the display date as per the Browser's timezone
                if (_this.logintopCourse.length > 0) {
                    //console.log("this.logintopCourse.length > 0 " + this.logintopCourse.length);
                    //console.log("Timezone exists and there are top courses too, will calculte timezone  based date for each " + this.timezone);
                    _this.logintopCourse.forEach(function (topCourse) {
                        //console.log("Timezone exists and there are top courses too, before change date ==>" + topCourse.courseFullName + "<<>>"
                        //+ topCourse.displayStartDate);
                        topCourse.displayStartDate = _this.timeZonechange(topCourse.courseStartDTime, _this.timezone);
                        //console.log("Timezone exists and there are top courses too, timezone  based date ==>" + topCourse.courseFullName + "<<>>"
                        //+ topCourse.displayStartDate);
                    });
                    // for (let i = 0; i <= 2; i++) {
                    //   this.logintopCourse.push(this.logintopCourse[0]);
                    // }
                }
            }
        }, function (error) {
            _this.alertService.error(error);
            _this.loading = false;
        });
    };
    SignupComponent.prototype.counterFn = function (maxNumber, type) {
        var _this = this;
        var that = this;
        if (type == 1) {
            this.sessionCounter = Observable.interval(50).subscribe(function (x) {
                if (that.sessionCount < maxNumber) {
                    that.sessionCount++;
                }
                else {
                    that.sessionCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
        if (type == 2) {
            this.meetingCounter = Observable.interval(50).subscribe(function (x) {
                if (that.meetingCount < maxNumber) {
                    that.meetingCount++;
                }
                else {
                    that.meetingCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
        if (type == 3) {
            this.countryCounter = Observable.interval(80).subscribe(function (x) {
                if (that.countryCount < maxNumber) {
                    that.countryCount++;
                }
                else {
                    that.countryCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
    };
    SignupComponent.prototype.signUpNowClick = function () {
        $(".loginBtnn.headerLoginButton").trigger("click");
    };
    SignupComponent.prototype.showall = function (t) {
        if (t) {
            $(".showMore").css("display", "block");
            this.loadMore = "Show Less";
            this.boolFlag = false;
        }
        else {
            $(".showMore").css("display", "none");
            this.loadMore = "Load More";
            this.boolFlag = true;
        }
    };
    SignupComponent.prototype.timeZonechange = function (dateTimeWithTimeZone, timezone) {
        var displayStartDateOnlyConverted = this.convertTimezone(timezone, 'date', dateTimeWithTimeZone);
        //console.log("timeZonechange , displayStartDateOnlyConverted ==>" + displayStartDateOnlyConverted);
        if (localStorage.getItem('timezone') == null) {
            localStorage.setItem('timezone', timezone);
        }
        return displayStartDateOnlyConverted;
    };
    SignupComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            //console.log("convertTimezone , inside if date");
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            //console.log("convertTimezone , inside if date, setDate ==>" + setdate);
            return setdate.tz(timezone).format('MM/DD/YYYY HH:mm');
        }
    };
    SignupComponent.prototype.processAndHandleErrorThrown = function () {
        var _this = this;
        this.thrownErrorCheckerSubscriber = this.errorHandlerService.errorMessage$.subscribe(function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent.prototype.register = function () {
        var _this = this;
        this.showSpinner = true;
        //console.log("..............test.........."+this.model.firstName.charAt(0).toUpperCase()  + this.model.firstName.slice(1));
        //console.log("The captcha===>" + this.model.recaptchaToken);
        if (this.model.userCredential.plainTextPassword == this.cplainTextPassword) {
            this.loading = true;
            this.model.firstName = this.model.firstName.charAt(0).toUpperCase() + this.model.firstName.slice(1);
            this.model.lastName = this.model.lastName.charAt(0).toUpperCase() + this.model.lastName.slice(1);
            this.userService.signup(this.model)
                .subscribe(function (data) {
                console.log(data);
                // this.alertService.success('Registration successful', true);
                localStorage.setItem('authorization', data.jwtToken);
                _this.showSpinner = false;
                _this.router.navigate(['/signup']);
            }, function (error) {
                _this.handleError(error);
            });
        }
    };
    SignupComponent.prototype.handleError = function (error) {
        var _this = this;
        this.showErrorMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
        }
    };
    SignupComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
    };
    return SignupComponent;
}());
export { SignupComponent };
var SignupComponent2 = /** @class */ (function () {
    function SignupComponent2(data, router, userService, alertService) {
        this.data = data;
        this.router = router;
        this.userService = userService;
        this.alertService = alertService;
        this.user = {};
        this.userAddresses = { countryTO: {} };
        this.userAddresss = [{}];
        this.userSubType = {};
        this.userEducation = {};
        this.countries = [];
        this.workExpStartDateStartMonth = "";
        this.fromYear = "";
        this.workExpEndDateStartMonth = "";
        this.toYear = "";
        this.isPresent = false;
        this.results = [];
        this.usertyperesults = [];
        this.cityresults = [];
        this.eduInstresults = [];
        this.selectedCountryId = -1;
        this.selectedStateId = -1;
        this.stateIdNameMap = {};
        //cityIdNameMap: any = {};
        this.time_zone = "";
        this.loading = false;
        // Error Handler
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Error !!";
        this.showErrorMessages = [];
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isValidationError = true;
        this.isCorporateUser = false;
        this.frommonths = [];
        this.frommonths.push({ label: 'January', value: '01' });
        this.frommonths.push({ label: 'Feburary', value: '02' });
        this.frommonths.push({ label: 'March', value: '03' });
        this.frommonths.push({ label: 'April', value: '04' });
        this.frommonths.push({ label: 'May', value: '05' });
        this.frommonths.push({ label: 'June', value: '06' });
        this.frommonths.push({ label: 'July', value: '07' });
        this.frommonths.push({ label: 'August', value: '08' });
        this.frommonths.push({ label: 'September', value: '09' });
        this.frommonths.push({ label: 'October', value: '10' });
        this.frommonths.push({ label: 'November', value: '11' });
        this.frommonths.push({ label: 'December', value: '12' });
        this.tomonths = [];
        this.tomonths.push({ label: 'January', value: '01' });
        this.tomonths.push({ label: 'Feburary', value: '02' });
        this.tomonths.push({ label: 'March', value: '03' });
        this.tomonths.push({ label: 'April', value: '04' });
        this.tomonths.push({ label: 'May', value: '05' });
        this.tomonths.push({ label: 'June', value: '06' });
        this.tomonths.push({ label: 'July', value: '07' });
        this.tomonths.push({ label: 'August', value: '08' });
        this.tomonths.push({ label: 'September', value: '09' });
        this.tomonths.push({ label: 'October', value: '10' });
        this.tomonths.push({ label: 'November', value: '11' });
        this.tomonths.push({ label: 'December', value: '12' });
    }
    SignupComponent2.prototype.ngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        this.userAddresses.countryTO.countryId = null;
        this.userService.country().subscribe(function (data) {
            _this.countries = data;
            _this.userService.userCountry().subscribe(function (result) {
                var country_name = result.country_name;
                console.log('country=' + country_name);
                _this.time_zone = result.time_zone["name"];
                console.log(result.time_zone);
                console.log("this.time_zone = " + _this.time_zone);
                for (var i = 0, len = data.length; i < len; i++) {
                    var country = data[i];
                    if (country.countryFullName === country_name) {
                        _this.userAddresses.countryTO.countryId = country.countryId;
                        _this.selectedCountryId = country.countryId;
                        _this.userAddresses.city = result.city;
                        _this.user.userLoggedInIPAddress = result.ip;
                        break;
                    }
                }
                _this.showSpinner = false;
            }, function (error) {
                _this.showSpinner = false;
            });
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.searcheduinst = function (event) {
        this.filtereduins(event.query);
    };
    SignupComponent2.prototype.filtereduins = function (query) {
        var _this = this;
        this.userService.filterEduins(query)
            .subscribe(function (data) {
            _this.eduInstresults = data.map(function (eduInsObj) { return eduInsObj.educationalInstitutionFullName; });
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.searchusertype = function (event) {
        this.filterusertype(event.query);
    };
    SignupComponent2.prototype.filterusertype = function (query) {
        var _this = this;
        this.userService.filterUsertype(query)
            .subscribe(function (data) {
            _this.usertyperesults = data.map(function (userTypeObj) { return userTypeObj.userSubTypeMaster; });
            var previousIsCorporateUser = _this.isCorporateUser;
            _this.checkIfUSerTypeSelectedExistsInUvsity();
            if (previousIsCorporateUser != _this.isCorporateUser) {
                // clear out the edu ins/org title/degree course and campus/location fields
                if (_this.isCorporateUser == true) {
                    _this.userEducation.userEducationEducationInstitution = null; //Edu Institution
                    _this.userEducation.userEducationSubject = null; //Subject
                    _this.userEducation.userEducationCampus = null; //Campus
                    _this.userEducation.userEducationDegreeCourse = null; //Degree Course
                    if (_this.workExpStartDateStartMonth == null || _this.workExpStartDateStartMonth == '') {
                        _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                    }
                    if (_this.workExpEndDateStartMonth == null || _this.workExpEndDateStartMonth == '') {
                        _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                    }
                }
                else {
                    _this.userEducation.userEducationEducationInstitution = null; //Organization
                    _this.userEducation.userEducationCampus = null; //Location
                    _this.userEducation.userEducationDegreeCourse = null; // Title / Designation
                    _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                    _this.fromYear = '';
                    _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                    _this.toYear = '';
                    _this.isPresent = false;
                }
            }
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.selectStartDate = function (startDate) {
        console.log("Printing the start datetime");
        console.log(startDate);
    };
    SignupComponent2.prototype.selectFirstElementInSearchList = function () {
        if (this.usertyperesults != null && this.usertyperesults.length) {
            if (this.usertyperesults.length > 0) {
                this.userSubType.userSubTypeMaster = this.usertyperesults[0];
            }
        }
        else {
            //this.createInfoAlert("No matching results for User type, switching to Corporate profile.");
            this.isCorporateUser = true;
        }
    };
    SignupComponent2.prototype.checkIfUSerTypeSelectedExistsInUvsity = function () {
        this.isCorporateUser = true;
        if (this.usertyperesults != null && this.usertyperesults.length) {
            if (this.usertyperesults.length > 0) {
                this.isCorporateUser = false;
            }
        }
    };
    SignupComponent2.prototype.onChange = function (countryid) {
        this.selectedCountryId = countryid;
    };
    SignupComponent2.prototype.searchstate = function (event) {
        this.filterstate(this.selectedCountryId, event.query);
    };
    SignupComponent2.prototype.filterstate = function (countryid, queryState) {
        var _this = this;
        this.userService.filterState(countryid, queryState)
            .subscribe(function (data) {
            _this.results = data.map(function (stateObj) { return stateObj.stateFullName; });
            _this.stateIdNameMap = {};
            data.forEach(function (stateObj, index) {
                this.stateIdNameMap[stateObj.stateFullName] = stateObj.stateId;
                console.log("State Name Id Map ==>" + this.stateIdNameMap);
            }, _this);
            console.log("State==>" + data);
            console.log("State Name Id Map ==>" + _this.stateIdNameMap);
            console.log("State filter results ==>" + _this.results);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.handleDropdownClick = function (state) {
        if (state != null && state != undefined) {
            this.selectedStateId = this.stateIdNameMap[state];
        }
    };
    SignupComponent2.prototype.searchcity = function (event, state) {
        console.log("SearchCty method called, that means completemethod of the City Autocomplete called.");
        console.log("The state passed to searchCity is ==>" + state);
        if (this.selectedStateId == -1) {
            console.log("The selected state Id is -1, will not perform filtering.");
            console.log("Returning.");
            return;
            //this.selectedStateId = this.stateIdNameMap[state];
            //console.log("The selected state Id is ==>" + this.selectedStateId);
        }
        this.filtercity(this.selectedStateId, event.query);
    };
    SignupComponent2.prototype.filtercity = function (stateId, queryCity) {
        var _this = this;
        this.userService.filterCity(stateId, queryCity)
            .subscribe(function (data) {
            _this.cityresults = data.map(function (cityObj) { return cityObj.cityFullName; });
            //this.cityIdNameMap = {};
            /*data.forEach(cityObj, index) {
              this.cityIdNameMap[cityObj.cityFullName] = cityObj.cityId;
            }*/
            console.log("City==>" + data);
            //console.log("City Name Id Map ==>" + this.cityIdNameMap);
            console.log("City filter results ==>" + _this.cityresults);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.register2 = function () {
        var _this = this;
        this.showSpinner = true;
        this.user.userSubType = this.userSubType;
        this.user.userEducation = this.userEducation;
        this.userAddresss[0] = this.userAddresses;
        this.user.userAddresses = this.userAddresss;
        console.log("Register haha2" + this.workExpStartDateStartMonth);
        console.log("Register haha2" + this.workExpEndDateStartMonth);
        this.user.workExpStartDate = this.workExpStartDateStartMonth + '/01/' + this.fromYear;
        this.user.workExpEndDate = this.workExpEndDateStartMonth + '/01/' + this.toYear;
        this.user.isPresent = this.isPresent;
        this.user.timeZone = this.time_zone;
        this.userService.signup2(this.user)
            .subscribe(function (data) {
            console.log(data);
            _this.showSpinner = false;
            _this.data.storage = {
                userdata: {
                    user: data
                }
            };
            //this.alertService.success('Registration successful', true);
            _this.router.navigate(['/confirm']);
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    SignupComponent2.prototype.convertMonth = function (mon) {
        var month = '01';
        switch (mon) {
            case 'January':
                month = '01';
                break;
            case 'February':
                month = '02';
                break;
            case 'March':
                month = '03';
                break;
            case 'April':
                month = '04';
                break;
            case 'May':
                month = '05';
                break;
            case 'June':
                month = '06';
                break;
            case 'July':
                month = '07';
                break;
            case 'August':
                month = '08';
                break;
            case 'September':
                month = '09';
                break;
            case 'October':
                month = '10';
                break;
            case 'November':
                month = '11';
                break;
            case 'December':
                month = '12';
                break;
        }
        return month;
    };
    SignupComponent2.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    SignupComponent2.prototype.handleError = function (error) {
        var _this = this;
        this.showErrorMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        if (error.isInfo) {
            console.log("Info Message");
            this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.showErrorMessages.push(error.infoMessage);
            this.showErrorPopupWidthInPercentage = "30%";
            this.showErrorModalDialog = true;
            return;
        }
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
        }
    };
    SignupComponent2.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
    };
    return SignupComponent2;
}());
export { SignupComponent2 };
//Signup Popup
var SignupPopupComponent = /** @class */ (function () {
    function SignupPopupComponent(data, router, userService, alertService, errorHandlerService) {
        this.data = data;
        this.router = router;
        this.userService = userService;
        this.alertService = alertService;
        this.errorHandlerService = errorHandlerService;
        this.model = { userCredential: { plainTextPassword: "" }, emailId: "", timeZone: "", userLoggedInIPAddress: "" };
        this.loading = false;
        this.cplainTextPassword = "";
        this.barLabel = "Password strength:";
        this.logintopCourse = [];
        // Error Handler
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Error !!";
        this.showErrorMessages = [];
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.isValidationError = true;
        this.searchfname = "";
        this.searchlname = "";
        this.userRegistrationTimezone = "";
        this.userLoggedInIPAddress = "";
        this.isSignUp = false;
        this.SignupDone = new EventEmitter();
    }
    SignupPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userRegistrationTimezone = localStorage.getItem("userRegistrationTimezone");
        this.userLoggedInIPAddress = localStorage.getItem("userLoggedInIPAddress");
        this.userService.topcourse()
            .subscribe(function (data) {
            //console.log(data);
            _this.logintopCourse = data;
            //console.log(this.logintopCourse);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            //console.log("Timezone ===> " + this.timezone);
            if (_this.timezone != null) {
                //console.log("Timezone is not null===> " + this.timezone);
                // If there are top courses, then change the display date as per the Browser's timezone
                if (_this.logintopCourse.length > 0) {
                    //console.log("this.logintopCourse.length > 0 " + this.logintopCourse.length);
                    //console.log("Timezone exists and there are top courses too, will calculte timezone  based date for each " + this.timezone);
                    _this.logintopCourse.forEach(function (topCourse) {
                        //console.log("Timezone exists and there are top courses too, before change date ==>" + topCourse.courseFullName + "<<>>"
                        //+ topCourse.displayStartDate);
                        topCourse.displayStartDate = _this.timeZonechange(topCourse.courseStartDTime, _this.timezone);
                        //console.log("Timezone exists and there are top courses too, timezone  based date ==>" + topCourse.courseFullName + "<<>>"
                        //+ topCourse.displayStartDate);
                    });
                }
            }
        }, function (error) {
            _this.alertService.error(error);
            _this.loading = false;
        });
    };
    SignupPopupComponent.prototype.timeZonechange = function (dateTimeWithTimeZone, timezone) {
        var displayStartDateOnlyConverted = this.convertTimezone(timezone, 'date', dateTimeWithTimeZone);
        //console.log("timeZonechange , displayStartDateOnlyConverted ==>" + displayStartDateOnlyConverted);
        if (localStorage.getItem('timezone') == null) {
            localStorage.setItem('timezone', timezone);
        }
        return displayStartDateOnlyConverted;
    };
    SignupPopupComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            //console.log("convertTimezone , inside if date");
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            //console.log("convertTimezone , inside if date, setDate ==>" + setdate);
            return setdate.tz(timezone).format('MM/DD/YYYY HH:mm');
        }
    };
    SignupPopupComponent.prototype.processAndHandleErrorThrown = function () {
        var _this = this;
        this.thrownErrorCheckerSubscriber = this.errorHandlerService.errorMessage$.subscribe(function (error) {
            _this.handleError(error);
        });
    };
    SignupPopupComponent.prototype.register = function () {
        var _this = this;
        this.showSpinner = true;
        //console.log("..............test.........."+this.model.firstName.charAt(0).toUpperCase()  + this.model.firstName.slice(1));
        //console.log("The captcha===>" + this.model.recaptchaToken);
        if (this.model.userCredential.plainTextPassword == this.cplainTextPassword) {
            this.loading = true;
            this.model.firstName = this.model.firstName.charAt(0).toUpperCase() + this.model.firstName.slice(1);
            this.model.lastName = this.model.lastName.charAt(0).toUpperCase() + this.model.lastName.slice(1);
            this.model.timeZone = this.userRegistrationTimezone;
            this.model.userLoggedInIPAddress = this.userLoggedInIPAddress;
            this.userService.signup(this.model)
                .subscribe(function (data) {
                console.log(data);
                // // this.alertService.success('Registration successful', true);
                // localStorage.setItem('authorization', data.jwtToken);
                // this.showSpinner = false;
                // this.router.navigate(['/dashboard']);
                _this.showSpinner = false;
                _this.data.storage = {
                    userdata: {
                        user: data
                    }
                };
                //this.alertService.success('Registration successful', true);
                // this.router.navigate(['/confirm']);
                _this.createInfoAlert("Almost done! Check your email " + _this.model.emailId + " to confirm your account.");
            }, function (error) {
                _this.handleError(error);
                _this.showSpinner = true;
            });
        }
    };
    SignupPopupComponent.prototype.createInfoAlert = function (alert) {
        var tempObj = {
            showErrorMessageTitle: "Success!!",
            showErrorMessages: alert,
            isValidationError: false,
            showErrorPopupWidthInPercentage: "100%",
            showErrorModalDialog: true,
            isSignUp: true
        };
        this.SignupDone.emit(tempObj);
    };
    SignupPopupComponent.prototype.handleError = function (error) {
        var _this = this;
        this.showErrorMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = "Info!!";
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
        }
        else {
            this.errorHandlerService.throwError(error);
        }
    };
    SignupPopupComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
        //this.router.navigate(['/login']);
    };
    return SignupPopupComponent;
}());
export { SignupPopupComponent };
//# sourceMappingURL=signup.component.js.map